module.exports = __webpack_public_path__ + "img/main-0_m.a7c99a91.jpg";